var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_2550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 4.125C1.875 2.88756 1.875 2.26885 2.25942 1.88442C2.64385 1.5 3.26256 1.5 4.5 1.5C5.73744 1.5 6.35615 1.5 6.74058 1.88442C7.125 2.26885 7.125 2.88756 7.125 4.125C7.125 5.36244 7.125 5.98115 6.74058 6.36558C6.35615 6.75 5.73744 6.75 4.5 6.75C3.26256 6.75 2.64385 6.75 2.25942 6.36558C1.875 5.98115 1.875 5.36244 1.875 4.125Z",
    stroke: "#626F86",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74264 11.7427C3.57107 10.9142 3.98528 10.5 4.5 10.5C5.01472 10.5 5.42894 10.9142 6.25736 11.7427C7.08579 12.5711 7.5 12.9853 7.5 13.5C7.5 14.0147 7.08579 14.4289 6.25736 15.2573C5.42894 16.0858 5.01472 16.5 4.5 16.5C3.98528 16.5 3.57107 16.0858 2.74264 15.2573C1.91421 14.4289 1.5 14.0147 1.5 13.5C1.5 12.9853 1.91421 12.5711 2.74264 11.7427Z",
    stroke: "#626F86",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75V10.5M7.5 13.5H11.25",
    stroke: "#626F86",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.5C11.25 12.2626 11.25 11.6438 11.6344 11.2594C12.0188 10.875 12.6376 10.875 13.875 10.875C15.1124 10.875 15.7312 10.875 16.1156 11.2594C16.5 11.6438 16.5 12.2626 16.5 13.5C16.5 14.7374 16.5 15.3562 16.1156 15.7406C15.7312 16.125 15.1124 16.125 13.875 16.125C12.6376 16.125 12.0188 16.125 11.6344 15.7406C11.25 15.3562 11.25 14.7374 11.25 13.5Z",
    stroke: "#626F86",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_2550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelation);
export default __webpack_public_path__ + "static/media/relation.bad1e3c197b0be0a7bb388cb03e7bd76.svg";
export { ForwardRef as ReactComponent };